import React from 'react';
import "./ServiceListSkeleton.css"

const ServiceCardListSkeleton = () => (
    <div className="skeleton-card">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-date"></div>
        <div className="skeleton skeleton-icon"></div>
    </div>
);

const ServiceCardDetailsSkeleton = () => (
    <div className="details-skeleton">
        <div className="details-section">
            <div className="details-header skeleton"></div>
            <div className='details-row-wrapper'>
                <div className="details-row">
                    <div className="details-label skeleton"></div>
                    <div className="details-value skeleton"></div>
                </div>
                <div className="details-row">
                    <div className="details-label skeleton"></div>
                    <div className="details-value skeleton"></div>
                </div>
                <div className="details-row">
                    <div className="details-label skeleton"></div>
                    <div className="details-value skeleton"></div>
                </div>
            </div>
        </div>
    </div>
);

const ServiceListSkeleton = ({ count = 3, type = 'list' }) => (
    <>
        {type === 'details' ?
            Array.from({ length: count }).map((_, index) => (
                <ServiceCardDetailsSkeleton key={index}/>
            ))
        :
            Array.from({ length: count }).map((_, index) => (
                <ServiceCardListSkeleton key={index} />
            ))
        }
    </>
);

export default ServiceListSkeleton;